module.exports = __webpack_public_path__ + "static/media/img-home7.a3d48427.jpg";